import { action as apiAction } from 'api/Api'
import {
  setStartDate as setCardStartDate
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  startDate: number
}

export default (payload: Payload) => async dispatch => {
  const { id, startDate } = payload

  const optimisticAction = optimisticDispatch(dispatch, setCardStartDate({
    id,
    startDate
  }))

  try {
    await apiAction('SetStartDate', {
      cardId: id,
      timestamp: startDate
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
